export const Statuses = {
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    ONGOING: "ONGOING",
    RESOLVED: "RESOLVED",
    VERIFIED: "VERIFIED",
    DRAFTED: "DRAFTED",
    SOLD:"SOLD",
    APPROVED: "APPROVED",
    ACTIVE: 'ACTIVE',
    REJECTED: "REJECTED",
}

export const BuildingType = {
    RESIDENTIAL: "RESIDENTIAL",
    COMMERCIAL: "COMMERCIAL",
}

export const typeOfApplications = {
    BUY: "BUY",
    RENT: "RENT",
    CLEAN: "CLEAN",
    FIX: "FIX",
    VERIFY: "VERIFY",
    RELIEF: "RELIEF",
}